<div class="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col gap-2">
  @for (t of toast.toasts(); track t.id) {
    <div
      class="pointer-events-auto flex items-start gap-3 rounded-lg border border-l-4 border-slate-200 bg-white px-4 py-3 shadow-lg dark:border-slate-700 dark:bg-slate-800"
      [class]="accent(t.type)"
    >
      <span class="text-base">{{ icon(t.type) }}</span>
      <p class="max-w-xs text-sm text-slate-700 dark:text-slate-200">{{ t.message }}</p>
      <button
        type="button"
        (click)="toast.dismiss(t.id)"
        class="cursor-pointer text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
        aria-label="Fermer"
      >
        ✕
      </button>
    </div>
  }
</div>
